export enum RoleActions {
  ACCESS_VIRTA = "access-virta",
  ACCESS_GAAS = "access-gaas",
  ACCESS_GAS_OCI_ONLY = "access-gas-oci-only",
  ACCESS_DEFAULT_GAS_SHOPS = "access-default-gas-shops",
  ACCESS_GLOBAL_GAS_SHOP = "access-global-gas-shop",
  ACCESS_EQUIVOLT_TCO_CALCULATOR = "access-equivolt-tco-calculator",
  PREVIEW_ALL_APPS = "preview-all-apps",
  GAS_SHOP_SEE_PRICES = "gas-shop-see-prices",
}
